import React, { Component } from 'react';
import styled, { withTheme } from 'styled-components';
import { isEqual } from 'lodash';
import helpers from 'helpers';
import ContentTile from 'components/atoms/layout/ContentTile';
import ContentHeader from 'components/atoms/layout/ContentHeader';

const WIDTH_MULTIPLIER = 62.5; // 100 / Max RealValue score = 100 / 1.6 = 62.5

const ContentWrapper = styled.div`
    margin-bottom: 10px;
`;

const Row = styled.div`
`;

const HeaderCell = styled.div`
    background-color: ${props => props.theme.colors.lightgray};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 33%;
    margin-right: 1px;
    margin-bottom: 1px;
    text-transform: uppercase;
    padding: 3px 10px;
    color: #000;
`;

const TextCell = styled(HeaderCell)`
    justify-content: flex-start;
    background-color: #fff;
    border: 1px solid ${props => props.theme.colors.lightgray};
    text-transform: none;
`;
const NumberCell = styled(HeaderCell)`
    justify-content: flex-end;
    background-color: #fff;
    border: 1px solid ${props => props.theme.colors.lightgray};
    text-transform: none;
`;

const LineChartWrapper = styled.div`
    display: block;
    width: 99%;
    height: 7px;
`;

const LineFill = styled.span`
    display: block;
    width: ${props => props.value * WIDTH_MULTIPLIER}%;
    height: 100%;
    background-color: ${props => props.theme.colors.primary};
    position: relative;
    overflow: hidden;
    animation: expandWidth 2s;

    @keyframes expandWidth {
        0% { width: 0; }
        100% { width: ${props => props.value * WIDTH_MULTIPLIER}; }
    }
`;

const generateRows = data => (
    data.map((row, index) => (
        <Row key={index}>
            <TextCell>{row.audience}</TextCell>
            <NumberCell>{row.costPerSale}</NumberCell>
            <NumberCell>{row.realValue}</NumberCell>
            <LineChartWrapper>
                <LineFill value={row.realValue}/>
            </LineChartWrapper>
        </Row>
    ))
);

class RealValueAudiences extends Component {
    shouldComponentUpdate(nextProps) {
        if (isEqual(nextProps.data, this.props.data)) {
            return false;
        }
        return true;
    }

    render() {
        const { data = [] } = this.props;

        return (
            <ContentTile padding={helpers.contentPadding('chart-with-legend')}>
                <ContentHeader hideCSVExport={true} type={'table'}>{this.props.title}</ContentHeader>
                <ContentWrapper>
                    <Row>
                        <HeaderCell>Audience</HeaderCell>
                        <HeaderCell>Cost/Sale</HeaderCell>
                        <HeaderCell>RealValue Score</HeaderCell>
                    </Row>
                    {generateRows(data)}
                </ContentWrapper>
            </ContentTile>
        );
    }
}

export default withTheme(RealValueAudiences);



// WEBPACK FOOTER //
// ./src/components/molecules/charts/labs/RealValueAudiences.js